import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=0bfaaa04&scoped=true"
import script from "./transactions.vue?vue&type=script&lang=js"
export * from "./transactions.vue?vue&type=script&lang=js"
import style0 from "./transactions.vue?vue&type=style&index=0&id=0bfaaa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfaaa04",
  null
  
)

export default component.exports